import { DriveOnDisplayableTaskDto as DriveonTask } from '@/generated/model';

export function getTaskAddress(task: DriveonTask): string | undefined {
  //if pg5ReferencNumber is defined the task's type is ICP otherwise it is PG5
  return task.pg5ReferenceNumber ? task.consumptionLocation : task.technicalLocation;
}
